
<script>
    import SchoolRepo from '../repos/SchoolRepo';
    import CategoryRepo from '../repos/CategoryRepo';
    import CommentRepo from '../repos/CommentRepo';
    import LessonRepo from '../repos/LessonRepo';
    import NewsRepo from '../repos/NewsRepo';
    import STBYLessonRepo from '../repos/STBYLessonRepo';
    import SentenceRepo from '../repos/SentenceRepo';
    import StudentRepo from '../repos/StudentRepo';
    import TicketRepo from '../repos/TicketRepo';
    import PremadeCategoryRepo from '../repos/PremadeCategoryRepo';
    import PremadeSentenceRepo from '../repos/PremadeSentenceRepo'
    import PremadeCommentRepo from '../repos/PremadeCommentRepo'
    import MagicWordRepo from '../repos/MagicWordRepo'
    import HelperArrays from '../services/HelperArrays'

    export default {
        data(){
            return {
                schoolRepo: new SchoolRepo(),
                categoryRepo: new CategoryRepo(),
                commentRepo: new CommentRepo(),
                lessonRepo: new LessonRepo(),
                newsRepo: new NewsRepo(),
                stbyLessonRepo: new STBYLessonRepo(),
                sentenceRepo: new SentenceRepo(),
                studentRepo: new StudentRepo(),
                ticketRepo: new TicketRepo(),
                premadeCategoryRepo: new PremadeCategoryRepo(),
                premadeSentenceRepo: new PremadeSentenceRepo(),
                premadeCommentRepo: new PremadeCommentRepo(),
                magicWordRepo: new MagicWordRepo(),
                helperArrays : new HelperArrays(),
                schools : [],
                subscription_status: [
                    //{id:"'ACTIVE','TRIALING','PAST_DUE','DELETED'", text:"ANY"},
                    {id:"ACTIVE", text:"ACTIVE"},
                    {id:"TRIALING", text:"TRIALING"},
                    {id:"PAST_DUE", text:"PAST DUE"},
                    {id:"DELETED", text:"DELETED"},
                ],
                subscription_plans: [
                    {id:"527533,527534,527535", text:"ANY"},
                    {id:"527533", text:"MOTHLY"},
                    {id:"527534", text:"SIX  MONTHS"},
                    {id:"527535", text:"TWELVE MONTHS"},
                ],
                MAGIC_EARS      : {id:1, name:'Magic Ears'},
                VIPKID          : {id:3, name:'VIPKID'},
                SUB_STATUS_ANY  : null,
                SUB_PLAN_ANY    : "527533,527534,527535",

                material: [
                    ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5'],
                    ['#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50'],
                    ['#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800'],
                    ['#FF5722', '#795548', '#9E9E9E', '#607D8B', '#3D4351'],
                ],
            }
        },
		created: function () {
		//console.log('mixin hook called')
		},
        computed: {

        },
        methods:{
            isArray(a) {
                return (!!a) && (a.constructor === Array);
            },
            isObject(a) {
                return (!!a) && (a.constructor === Object);
            },

            updateSentenceColor(sentences, categories){
                _.forEach(sentences, function(sen) {
                    _.forEach(categories, function(cat) {
                        let index = _.findIndex(sen.premadeCategories, function(c) { return c.id == cat.id; });
                        if( index !== -1){
                            sen.premadeCategories[index] = cat;
                        }
                    });
                });
                return sentences;
            },
            prepareSentencesForServer(choosedSentences){
                let sentences = [];
                let prev = -1;
                var i = 0;
                _.forEach(choosedSentences, function(value) {

                    if(!value.isJoiner){

                        sentences[i] = {
                            sentenceId: value.id,
                            order: i,
                            joiner: "",
                        };
                        prev = i;
                        i++;
                    }
                    else{
                        //if(prev > -1){
                            sentences[prev].joiner = value.text;
                        //}
                    }
                });

                return sentences;
            },
            prepareSentencesForClient(commentSentences){
                let sentences = [];
                let joiners = this.helperArrays.joiners();
                var i = 0;
                _.forEach(commentSentences, function(value) {
                    sentences.push({id:value.id, text: value.text, premadeCategories: value.premadeCategories});
                    if(value.pivot.joiner != ''){
                        _.forEach(joiners, function(value1) {
                            if(value.pivot.joiner == value1.text){
                                sentences.push(value1);
                            }
                        });
                        i++;
                    }
                    i++;
                });

                return sentences;
            },
            loadSchools(){
                this.schoolRepo.all().then(response => {
                this.schools = response.data.data;
              }).catch((response) =>{
                  return Promise.reject(response);
              });
            },
            stbySchools(items){
              items.forEach(function (item) {
                if( !['VIPKID', 'Magic Ears'].includes(item.name) ){
                  item['$isDisabled'] = true;
                }
              });
              //return result;
            },

            isMEFullFormat(str){
                str = str.toUpperCase();
                if (str === "") {
                    return true;
                }
                var res = str.split("-");
                if (res.length == 3) {
                    var str1 = res[0];
                    var str2 = res[1];
                    var str3 = res[2];
                    if (str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L") {
                        return true;
                    }
                }
                return false;
            },

            meLessonFormat(str, fullFormat = true){
                str = str.toUpperCase();
                if (str === "") {
                    return true;
                }
                var res = str.split("-");
                if (res.length !== 3) {
                    return false;
                }
                else {
                    var str1 = res[0];
                    var str2 = res[1];
                    var str3 = res[2];
                    var ch = true;
                    if(fullFormat){
                        if (str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L") {
                            if (str1.length === 0 || isNaN(str1) || str1.includes("E") || str2.length === 0 || isNaN(str2) || str2.includes("E") || str3.length === 0 || isNaN(str3) || str3.includes("E")) {
                                return false;
                            }
                            return true;
                        }
                        str1 = str1.substring(1, str1.length);
                        str2 = str2.substring(1, str2.length);
                        str3 = str3.substring(1, str3.length);
                    }

                    if (str1.length === 0 || isNaN(str1) || str1.includes("E") || str2.length === 0 || isNaN(str2) || str2.includes("E") || str3.length === 0 || isNaN(str3) || str3.includes("E")) {
                        return false;
                    }
                    return true;

                }
            },

            vkLessonFormat(str){
                str = str.toUpperCase();
                if (str === "") {
                    return true;
                }
                var res = str.split("-");

                if (res.length === 4) {
                    return this.is_trial_vipkid(res);
                }
                if (res.length === 5) {
                    return this.is_mc_vipkid(res);
                }
                return false;
            },

            is_trial_vipkid(parts){
                let str = parts[0];

                if(['MSCP'].includes(str)){
                    return this.is_mcsp_vipkid(parts);
                }
                if(!['T1','LT1'].includes(str)){
                    return false;
                }
                let str1 = parts[1];
                let str2 = parts[2];
                let str3 = parts[3];
                if (str1.length<2 || str2.length<3 || str3.length< 2 || str1[0] !== "U" || (str2[0] !== "L" && str2[1] !== "C") || str3[0] !== "L") {
                    return false;
                }
                str1 = str1.substring(1, str1.length);
                str2 = str2.substring(2, str2.length);
                str3 = str3.substring(1, str3.length);
                if (str1.length === 0 || str1.includes("E") || isNaN(str1) || str2.length === 0 || str2.includes("E") || isNaN(str2) || str3.length === 0 || str3.includes("E") || isNaN(str3)) {
                    return false;
                }
                return true;
            },

            is_mcsp_vipkid(parts){
                //skip first element
                let str1 = parts[1];
                let str2 = parts[2];
                let str3 = parts[3];
                if (str1.length<2 || str2.length<2 || str3.length< 2 || str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L"){
                    return false;
                }
                str1 = str1.substring(1, str1.length);
                str2 = str2.substring(1, str2.length);
                str3 = str3.substring(1, str3.length);
                if (str1.length === 0 || str1.includes("E") || isNaN(str1) || str2.length === 0 || str2.includes("E") || isNaN(str2) || str3.length === 0 || str3.includes("E") || isNaN(str3)) {
                    return false;
                }
                return true;
            },

            is_mc_vipkid(parts){
                let str = parts[0];
                let str4 = parts[4];
                if(['T1'].includes(str)){
                    if(str4.length !== 0 && !str4.includes("E") || !isNaN(str4)) {
                        parts.pop();
                        return this.is_trial_vipkid(parts);
                    }
                }
                if(!['BK','DG','FS','ST','ES','GM','MVP01','PH','PP','FT','TP','VV','W3','W2','W1','LT1','ME','MCS','MC','T1','IMC'].includes(str)){
                    return false;
                }
                let str1 = parts[1];
                let str2 = parts[2];
                let str3 = parts[3];
                if (str1.length<2 || str2.length<2 || str3.length< 3 || str1[0] !== "L" || str2[0] !== "U" || (str3[0] !== "L" && str3[1] !== "C")) {
                    return false;
                }
                str1 = str1.substring(1, str1.length);
                str2 = str2.substring(1, str2.length);
                str3 = str3.substring(2, str3.length);
                if (str1.length === 0 || str1.includes("E") || isNaN(str1)||
                    str2.length === 0 || str2.includes("E") || isNaN(str2) ||
                    str3.length === 0 || str3.includes("E") || isNaN(str3)||
                    str4.length === 0 || str4.includes("E") || isNaN(str4)) {
                    return false;
                }
                return true;
            },

            makeLink(text){
                return  (text || "").toString().replace(
                    /([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi,
                    function(match, space, url){
                        var hyperlink = url;
                        if (!hyperlink.match('^https?:\/\/')) {
                            hyperlink = 'http://' + hyperlink;
                        }
                        return space + '<a target="_blank" href="' + hyperlink + '">' + url + '</a>';
                    }
                );
            },

            snakeToCamelCase(str){
                return this.capitalize(str.replace(/(\_\w)/g, function(m){return " " + m[1].toUpperCase();}));
            },
            capitalize(s){
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },

            meDefaultAdditionalInfo(){
              return {
                  crown_page: "",
                  ending_song_length: "",
                  game: "",
                  id: "",
                  name: "",
                  other_key_words: "",
                  practice_words: "",
                  prop_ideas: "",
                  provider_full_id: "",
                  provider_id: "",
                  role_play_slides: "",
                  sentences: "",
                  show_time: "",
                  words: "",
              };
            },

            vkDefaultAdditionalInfo(){
                return {
                    assessment: '',
	                connected_speach: '',
	                digital_rewards: '',
	                discussion_questions: '',
	                goals: '',
	                google_slides: '',
	                grammar: '',
	                id: '',
	                intonation: '',
	                listening: '',
	                materials: '',
	                math: '',
	                name: '',
	                notes: '',
	                noun: '',
	                objective: '',
	                outline: '',
	                phonics: '',
	                phonics_reader: '',
	                project_options: '',
	                props: '',
	                provider_full_id: '',
	                reading: '',
	                reading_comp: '',
	                reward_system: '',
	                sentence_pattern: '',
	                sight_words: '',
	                social_science: '',
	                sounds: '',
	                tips_tricks: '',
	                verb: '',
	                vocabulary_strategies: '',
	                words: '',
                };
            },

            restDefaultAdditionalInfo(){
                return {
                    grammar: '',
	                id: '',
	                math: '',
	                name: '',
	                objective: '',
	                phonics: '',
	                project_options: '',
	                provider_full_id: '',
	                sentence_pattern: '',
	                sight_words: '',
	                social_science: '',
	                words: '',
                };
            },


        },
        mounted(){

        },

    }
</script>



// WEBPACK FOOTER //
// src/mixins/http-mixin.vue